<div *ngFor="let menu of parentMenu" class="menu-item">
	<ul class="menu-ul" *appUserRole="{ customRole: menu.requiredRoles }">
		<li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
			<a *ngIf="menu.routerLink && !menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
				[routerLink]="[menu.routerLink]" routerLinkActive="active-link"
				[routerLinkActiveOptions]="(menu.parentId != 0) ? { exact:false } : {exact:true}"
				(click)="onClick(menu.id)" [id]="'menu-item-'+menu.id">
				<mat-icon *ngIf="menu.icon" class="menu-icon">{{menu.icon}}</mat-icon>
				<mat-icon *ngIf="!menu.icon" [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
				<span class="menu-title">{{menu.title}}</span>
			</a>
		</li>
		<li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
			<a *ngIf="menu.href && !menu.subMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
				[attr.href]="menu.href || ''" [attr.target]="menu.target || ''" (click)="onClick(menu.id)"
				[id]="'menu-item-'+menu.id">
				<mat-icon *ngIf="menu.icon" class="menu-icon">{{menu.icon}}</mat-icon>
				<mat-icon *ngIf="!menu.icon" [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
				<span class="menu-title">{{menu.title}}</span>
			</a>
		</li>
		<li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
			<a *ngIf="menu.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center" (click)="onClick(menu.id)"
				[id]="'menu-item-'+menu.id">
				<mat-icon *ngIf="menu.icon" class="menu-icon">{{menu.icon}}</mat-icon>
				<mat-icon *ngIf="!menu.icon" [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
				<span class="menu-title">{{menu.title}}</span>
				<mat-icon class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
			</a>
		</li>
	</ul>
	<div *ngIf="menu.hasSubMenu" class="sub-menu" [id]="'sub-menu-'+menu.id">
		<app-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-menu>
	</div>
</div>